module.exports = __webpack_public_path__ + "assets/8871d580818c48ea880545db1844738d.png";